/* ════════════════════════════════════════════════════════════════
   ORÜGA CLICK — captura de pre-registro
   Envía a Klaviyo (Client Subscriptions API) + dispara Lead a Meta.
   La configuración (company id, list id) llega desde el template.
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var CFG = window.OC_CONFIG || {};
  var KLAVIYO_REVISION = '2024-10-15'; // Klaviyo versiona su API por fecha

  var form   = document.getElementById('oc-form');
  var done   = document.getElementById('oc-done');
  var fail   = document.getElementById('oc-fail');
  var submit = document.getElementById('oc-submit');
  if (!form) return;

  /* ── Scroll suave al formulario desde el CTA del hero ───────── */
  document.querySelectorAll('[data-scroll]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.getElementById('form');
      if (!target) return;
      e.preventDefault();
      window.scrollTo({ top: target.offsetTop - 60, behavior: 'smooth' });
      var first = document.getElementById('oc-nombre');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 500);
    });
  });

  /* ── Validación ─────────────────────────────────────────────── */
  function setError(input, message) {
    var field = input.closest('.oc-field');
    var slot  = form.querySelector('[data-error-for="' + input.id + '"]');
    if (slot) slot.textContent = message || '';
    if (field) field.classList.toggle('oc-field--invalid', Boolean(message));
    return !message;
  }

  /* Normaliza a E.164 chileno: +569XXXXXXXX.
     Sin esto llegan números que no se pueden usar en WhatsApp. */
  function normalizarFono(valor) {
    var d = (valor || '').replace(/\D/g, '');
    if (d.indexOf('56') === 0) d = d.slice(2);
    if (d.indexOf('0') === 0)  d = d.slice(1);
    if (d.length === 8) d = '9' + d;          // fijo antiguo escrito sin el 9
    if (d.length !== 9 || d.charAt(0) !== '9') return null;
    return '+56' + d;
  }

  function validar() {
    var nombre = document.getElementById('oc-nombre');
    var email  = document.getElementById('oc-email');
    var fono   = document.getElementById('oc-fono');

    var okNombre = setError(nombre, nombre.value.trim().length < 2 ? 'Escribe tu nombre' : '');
    var okEmail  = setError(email, /^\S+@\S+\.\S+$/.test(email.value.trim()) ? '' : 'Ingresa un email válido');
    var e164     = normalizarFono(fono.value);
    var okFono   = setError(fono, e164 ? '' : 'Ingresa un celular chileno, ej: +56 9 1234 5678');

    if (!(okNombre && okEmail && okFono)) return null;
    return { nombre: nombre.value.trim(), email: email.value.trim().toLowerCase(), fono: e164 };
  }

  /* ── Envío a Klaviyo ────────────────────────────────────────── */
  function suscribir(datos) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Landing Orüga Click',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: datos.email,
                first_name: datos.nombre,
                phone_number: datos.fono,
                properties: {
                  whatsapp: datos.fono,
                  producto_interes: 'Orüga Click',
                  origen: 'landing-preregistro',
                  fecha_registro: new Date().toISOString()
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: CFG.klaviyoListId } }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CFG.klaviyoCompanyId), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo respondió ' + res.status);
      return true;
    });
  }

  /* ── Eventos de conversión ──────────────────────────────────── */
  function trackearLead() {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        content_name: 'Orüga Click — Pre-registro',
        content_category: 'waitlist'
      });
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', { event_category: 'oruga_click' });
    }
  }

  /* ── Submit ─────────────────────────────────────────────────── */
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    // Honeypot: si viene relleno, es un bot. Fingimos éxito y no enviamos.
    if (form.querySelector('#oc-empresa').value) { mostrarExito(); return; }

    var datos = validar();
    if (!datos) return;

    fail.hidden = true;
    submit.disabled = true;
    submit.textContent = 'Guardando…';

    suscribir(datos)
      .then(function () {
        trackearLead();
        mostrarExito();
      })
      .catch(function (err) {
        console.error('[Orüga Click]', err);
        submit.disabled = false;
        submit.textContent = 'Guardar mi cupo con ' + (CFG.descuento || 5) + '% dcto.';
        fail.textContent = 'No pudimos guardar tu cupo. Revisa tu conexión e inténtalo de nuevo.';
        fail.hidden = false;
      });
  });

  function mostrarExito() {
    form.hidden = true;
    done.hidden = false;
    done.setAttribute('tabindex', '-1');
    done.focus();
  }
})();
